export default __webpack_public_path__ + "media/images/images/raty/like-2-948132caf8b20233a1ef1daec6eee49d.png";